interface Props {
    title: string;
    text: string;
}

const NotifyWrapper = ({ title, text }: Props) => {
    return (
        <div className="flex flex-col gap-1 min-w-0">
            <div className="font-chat-nick text-text_main text-[16px] font-extrabold tracking-[0.02em] leading-tight">
                {title}
            </div>
            <div className="font-chat-msg text-text_2 text-[13.5px] font-normal break-words whitespace-normal leading-snug">
                {text}
            </div>
        </div>
    );
};

export default NotifyWrapper;
